import { Pipe, PipeTransform } from '@angular/core';
import { isString } from 'util';

@Pipe({
  name: 'script'
})
export class ScriptPipe implements PipeTransform {
  transform(value: any, args?: string) {
    let result = value;
    if (isString(result)) {
      result = value.replace(
        /-|_/gi,
        (x: string) => {
          return ' ';
        }
      );
    }

    return result;
  }
}
